import {Module} from 'vuex';
import {RootState} from '@/types';
import ArticleAPI from '@/api/ArticleAPI';
import {SET_ARTICLE, SET_ARTICLES} from '@/store/mutationTypes';
import {namespace} from 'vuex-class';

export const articlesModule = namespace('articles');

export interface Article {
  [key: string]: any;
}

interface ArticleState {
  articles: Article[];
  article: Article | null;
}

export default <Module<ArticleState, RootState>>{
  namespaced: true,
  state: {
    articles: [],
    article: null,
  },
  mutations: {
    [SET_ARTICLES](state, data) {
      state.articles = data;
    },
    [SET_ARTICLE](state, data) {
      state.article = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await ArticleAPI.all(params);
        commit(SET_ARTICLES, data.data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async active({commit}, params = {}) {
      try {
        const {data} = await ArticleAPI.active(params);
        commit(SET_ARTICLES, data.data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await ArticleAPI.detail(id);
        commit(SET_ARTICLE, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
  getters: {},
};
